import config from '@/config'
const BASE_URI = config.serverUrl

export default {
  BASE_URI: BASE_URI,
  LOGGED_IN_USER_INFO: `${BASE_URI}user/me/info`,
  FE_GET_FILTER: (type, tenant = null) => `${BASE_URI}fe/${forTenant(tenant)}${type}/search`,
  CASE: `${BASE_URI}case`,
  SESSION_TOKEN: `${BASE_URI}session-token`
}

const forTenant = tenant => tenant ? `for-tenant/${tenant}/` : ''



// WEBPACK FOOTER //
// ./src/api/index.js